'use strict';

angular.module('mobile-apps').factory('UserTeamMembers', ['$resource',
	function ($resource) {
		return $resource(
			'v1/teams/userTeamMembers',
			{

			},
			{
				get:
				{
					method:'GET',
					isArray : true
				}
			}
		);
	}
]);
